import React, { useMemo } from 'react';
import { TypedMemo } from '../../common/types';
import { channelPostTotals } from '../promote/socialNumbers';
import { SerializedSocialChannel, SerializedSocialPost } from '../promote/types';
import { SocialTotalCard } from './SocialTotalCard';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialTotalsRowProps {
  /** The connected channels, in the platform order. A channel that is not connected has no card. */
  channels: SerializedSocialChannel[];
  /** Every post of the period, with no filter. Undefined while they load. */
  posts?: SerializedSocialPost[];
  /** True when the period has more posts than the app reads: the sums are a lower limit. */
  isCapped?: boolean;
}

/** One totals card per connected channel. On a phone the cards scroll sideways. */
const SocialTotalsRowComponent: React.FC<SocialTotalsRowProps> = ({ channels, posts, isCapped = false }) => {
  const cards = useMemo(
    () =>
      channels.map((channel) => (
        <SocialTotalCard
          key={channel.platform}
          channel={channel}
          totals={posts === undefined ? undefined : channelPostTotals(posts, channel.platform)}
          isCapped={isCapped}
        />
      )),
    [channels, isCapped, posts]
  );

  return <div className={styles.totals}>{cards}</div>;
};

export const SocialTotalsRow = TypedMemo(SocialTotalsRowComponent);
